define('adminSnippetsListView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'jquery',
  'windows',
  'tableView',
  'tableFieldView',
  'adminSnippetsListHeaderToolsView',
  'adminSnippetsListRowToolsView',
  'adminSnippetsEditPopupView',
  'entities/admin/snippets'
], function (
  Module,
  App,
  Backbone,
  _,
  $,
  Windows,
  TableView,
  FieldView,
  HeaderToolsView,
  RowToolsView,
  EditPopupView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'admin-snippets-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',

    setFields: function () {
      return [{
        name: 'Shortcut',
        label: _.i18n('admin.snippets.shortcut', null, 'Shortcut'),
        className: 'shortcut',
        bind: 'shortcut',
        modelEvent: 'change:shortcut'
      }, {
        name: 'Body',
        label: _.i18n('admin.snippets.body', null, 'Body'),
        className: 'body',
        bind: 'body',
        modelEvent: 'change:body'
      }, {
        name: 'Description',
        label: _.i18n('admin.snippets.description', null, 'Description'),
        className: 'description',
        bind: 'description',
        modelEvent: 'change:description'
      }, {
        name: 'Enabled',
        label: _.i18n('admin.snippets.enabled', null, 'Enabled'),
        className: 'enabled',
        bind: 'enabled',
        modelEvent: 'change:enabled'
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView,
        headerView: HeaderToolsView
      }];
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();
      if (this.fetchRequest) { this.fetchRequest.abort(); }
      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('snippets:get-url', { first: first, pageSize: pageSize }),
        success: function (items) {
          var models = _.map(items || [], function (item) {
            return App.request('snippets:model', item);
          });
          defer.resolve(models);
        }
      });
      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();
      if (this.fetchCountRequest) { this.fetchCountRequest.abort(); }
      this.fetchCountRequest = $.ajax({
        url: App.request('snippets:row-count-url'),
        success: function (resp) { defer.resolve(resp); }
      });
      return defer.promise();
    },

    onRowClick: function (rowView) {
      var tableView = this;
      var secId = rowView.model.get('secId');
      Windows.open({
        view: function () {
          return new EditPopupView({
            snippetSecId: secId,
            onConfirm: function () { tableView.refresh(); }
          });
        },
        title: _.i18n('admin.snippets.editTitle', null, 'Edit snippet'),
        width: 640,
        height: 620,
        modal: true
      });
    }
  });
});

